import { createFileRoute } from '@tanstack/react-router';

import { MissionDetailPage } from '@/features/missionDetail/MissionDetailPage';

export const Route = createFileRoute('/_app/missions/$missionId')({
	component: MissionDetailRoute,
});

function MissionDetailRoute() {
	const { missionId } = Route.useParams();
	return <MissionDetailPage key={missionId} missionId={missionId} />;
}
